import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import { ScopeProvider } from '@portal/pkg-authorization'
import CreateEntity from '@migrate/components/navigator/CreateEntity'

export const Route = createFileRoute('/_auth/entity/new')({
  component: RouteComponent,
  validateSearch: z.object({
    entityType: z.number(),
    parentEntity: z.number().optional(),
  }),
  beforeLoad: ({ context: { scopedEnablements }, search }) => {
    // A role scoped to some Entity Types holds "Entity.CREATE" on those alone, so the type being
    // created must grant it. A type the caller cannot reach fails closed.
    const scope = { entityTypeId: search.entityType }
    if (!scopedEnablements.for(scope).hasStandardEnablement('Entity', 'CREATE')) {
      throw redirect({
        to: '/403',
        replace: true,
      })
    }
    return { scope }
  },
})

function RouteComponent() {
  const search = Route.useSearch()
  const { scope } = Route.useRouteContext()
  return (
    <ScopeProvider scope={scope}>
      <CreateEntity entityType={search.entityType} parentEntity={search.parentEntity} />
    </ScopeProvider>
  )
}
